import axios from 'axios';
import Vue from 'vue'

export default {
    getMenuByCode(codeMenu) {
        return axios.get('/api/menu/list', { params: { codeMenu:codeMenu} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    trackingEventMenu(trackingBody) {
        return axios.post('/api/menu/tracking', trackingBody)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMenuByCodeForAnonymous(codeMenu, currentLang, groupId, tid) {
        return axios.get('/api/menu/get', { params: { codeMenu:codeMenu , codeLanguage:currentLang, groupId:groupId, tid: tid ? tid : ''} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemsWishlist(itemsId,codeMenu,codeLanguage) {

        const url = new URL(window.location.href);
        const tid = url.searchParams.get('tid');

        return axios.get('/api/menu/wishList', { params: { itemsId:itemsId.join(","),codeMenu:codeMenu,codeLanguage:codeLanguage, tid:tid } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveGroup(group) {
        return axios.post('/api/menu/save/group', group)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveSection(section) {
        return axios.post('/api/menu/save/section', section)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveSubSection(subSection) {
        return axios.post('/api/menu/save/sub-section', subSection)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveItem(data) {
        return axios.post('/api/menu/save/item',data)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addMenuItemImage(formData) {
        return axios.post('/api/menu/save/image-item',formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteMenuItemImage(imageName, id) {
        return axios.get('/api/menu/remove/image-item',{params:{imageName:imageName, id:id}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    saveThumbnailImageMenu(formData) {
        return axios.post('/api/menu/save/thumbnail-image',formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveBannerMenu(formData, secondThumbnailFrame) {
        return axios.post('/api/menu/save/banner-menu',formData, {params:{secondThumbnailFrame:secondThumbnailFrame}} , { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeBannerMenu(menuId, isThumbnail) {
        return axios.get('/api/menu/remove/banner-medias',{params: {menuId:menuId, isThumbnail:isThumbnail}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveSettingsMenu(settingsMenu) {
        return axios.post('/api/menu/save/style',settingsMenu)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeItem(itemId) {
        return axios.get('/api/menu/remove/item',{params :{itemId:itemId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeGroup(groupId) {
        return axios.get('/api/menu/remove/group',{params :{groupId:groupId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeSection(sectionId) {
        return axios.get('/api/menu/remove/section',{params :{sectionId:sectionId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeSubSection(subSectionId, sectionId) {
        return axios.get('/api/menu/remove/sub-section',{params :{subSectionId:subSectionId, sectionId:sectionId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    updateMenuItemImagePriority(updatedItemVariantImagePriority) {
        return axios.post('/api/image/update/priority',updatedItemVariantImagePriority)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    generateQrTables(menuId, start, end) {
        return axios.get('/api/menu/generate/qrtable', {
            params: {
                menuId: menuId,
                start: start,
                end: end
            },
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'qr_tables.zip');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            Vue.prototype.$snotify.error('Failed to download QR ZIP');
            console.error(error);
        });
    },

    getQrTables(menuId, start, end) {
        return axios.get('/api/menu/list/qrtables', {
                params: {
                menuId: menuId,
                start: start,
                end: end
            },
        })
        .then(response => {
            if (response && response.data) return response.data
        })
    },


    getMenuItemsByMenuCode(codeMenu) {
        return axios.get('/api/menu/items',{params:{codeMenu:codeMenu}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllMenuGroups(menuCode) {
        return axios.get('/api/menu/all-groups',{params:{menuCode:menuCode}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMenuGroups(menuCode) {
        return axios.get('/api/menu/get/list/group',{params:{menuCode:menuCode}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMenuSections(menuCode) {
        return axios.get('/api/menu/all-sections',{params:{menuCode:menuCode}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getMenuSubSections(menuCode) {
        return axios.get('/api/menu/all-sub-sections',{params:{menuCode:menuCode}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    checkSignatureForVirtualTables() {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');

        return axios.get('/api/menu/check-signature',{params:{menuCode:menuCode, tid:tid, ts:ts, did:did}})
        .then(response => {
            if (response && response.data) {
                window.location.href = response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }


}